import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-225dbcf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-sns-buttons sns sp" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "sns-item"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/static/image/pressrelease/icon_fb.svg",
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "sns-item"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/static/image/pressrelease/icon_x_button.svg",
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "sns-item"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/static/image/pressrelease/icon_note.svg",
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "separator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_follow_btn = _resolveComponent("follow-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasSns)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_ctx.userAccount.facebook)
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createElementVNode("a", {
                  href: _ctx.userAccount.facebook,
                  target: "_blank"
                }, _hoisted_6, 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          (_ctx.userAccount.twitter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("a", {
                  href: _ctx.userAccount.twitter,
                  target: "_blank"
                }, _hoisted_10, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          (_ctx.userAccount.noteUrl)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createElementVNode("a", {
                  href: _ctx.userAccount.noteUrl,
                  target: "_blank"
                }, _hoisted_14, 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasSns)
      ? (_openBlock(), _createElementBlock("span", _hoisted_15))
      : _createCommentVNode("", true),
    _createVNode(_component_follow_btn, {
      class: "follow",
      "user-account-id": _ctx.userAccount.userAccountId,
      "medium-id": _ctx.mediumId,
      app: _ctx.facebookAppKey,
      session: _ctx.facebookId
    }, null, 8, ["user-account-id", "medium-id", "app", "session"])
  ]))
}